class drop_down {

    constructor(select_id, template) {
        this.select_id = select_id;
        this.template = template;
    }

    get_select() {
        return $('#' + this.select_id);
    }

    fill_html_select() {
        this.html_select = new fl_html_select(this.select_id, this.template);
        this.html_select.get_li_data = this.get_li_data.bind(this);
        this.html_select.init();
    }

    out_of_stock(item) {

        let amount = String(item.protempo_stock);
        let clean =  amount.replace('+', '');

        if (clean * 1 <= 0) {
            return true;
        } else {
            return false;
        }

    }


    /**
     * Formats the stock information for an item.
     *
     * @param {Object} item - The item object.
     * @param {Object} texts - The text object.
     * @returns {string} - The formatted stock information.
     */
    format_stock(item, texts) {

        let stock = '';
        let icon_in_stock = ''; //<i class="fl-icon fa fa-check-circle"></i>';
        let icon_out_of_stock = ''; //<i class="fl-icon fa fa-stop-circle"></i>';

        if(item.dropdown_img_src == 'http://local.gasfedershop.ch/wp-content/uploads/sites/5/2017/12/ar16s_8-300x300.png') {
            console.log(item, ':pn>', item.purchase_note, ':oos>', this.out_of_stock(item), ':if>', texts.is_featherlight);
        }

        if (item.hahntype !== 'none') {
            if (texts.is_featherlight) {
                if ( this.out_of_stock(item) ) {
                    stock += icon_out_of_stock + "<span class='out_of_stock'>" + item.purchase_note + "</span>";
                } else {
                    stock += icon_in_stock + "<span class='in_stock'>" + texts.in_stock + " (" + item.protempo_stock + ")</span>";
                }
            } else {
                if (item.purchase_note !== '') {
                    stock += icon_out_of_stock + "<span class='out_of_stock'>" + item.purchase_note + "</span>";
                } else {
                    stock += icon_in_stock + "<span class='in_stock'>" + texts.in_stock + "</span>";
                }
            }
        }

        if (this.out_of_stock(item) && item.purchase_note !== '') {
            stock = '<span class="out-of-stock">' + stock + '</span>';
        }

        return stock;
    }

    /**
     * Formats a mounting part title based on its properties.
     * If the part type is 'none', it returns the original title.
     * If the part type is not 'none', it prefixes the title with 'M' followed by dschroefdraad,
     * and appends each part type capitalized with 'and' between the first and second parts.
     *
     * @param {Object} mp - The mounting part object
     * @param {string} mp.title - The original title of the mounting part
     * @param {string} mp.type_aanbouwdeel - The type of the mounting part (gaffel)
     * @param {string[]} mp.type_aanbouwdeel_array - An array of part types
     * @param {string} mp.dschroefdraad - The M size (M8, M10)
     * @returns {string} - The formatted mounting part title.
     */
    format_mp_title(mp) {

        // return the original title if the part types is 'none'
        if (mp.type_aanbouwdeel === 'none') {
            return mp.title;
        } else {

            let title = 'M' + mp.dschroefdraad + ' ';

            // return the original title it the part-types array is empty: `['']`
            if (mp.type_aanbouwdeel_array[0] === '') {
                // log faulty products with empty mounting part array
                title = mp.title;
            } else {

                // loop over the parts
                for (let i = 0; i < mp.type_aanbouwdeel_array.length; i++) {

                    // get the type of the mounting part
                    const type = mp.type_aanbouwdeel_array[i];

                    // add 'and' between first and second parts
                    if (mp.type_aanbouwdeel_array.length === 2 && i === 0) {
                        // capitalize the part names
                        title += ' ' + type[0].toUpperCase() + type.slice(1);
                        title += ' met ';
                    } else {
                        title += ' ' + type;
                    }

                }

                // const mp_length = mp && mp.elongationlength ? mp.elongationlength : false;
                // if (mp_length) {
                //     // @TODO: make measurement units variable: imperial/metric
                //     title += ' ' + mp_length + 'mm';
                // }

            }

            return title;

        }

    }

}
